import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { FormViewService } from '@xilo-mono/form-contracts';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'xilo-mono-form-viewer-intake-form',
  template: `
    <div #intakeForm class="xilo-mono-form-viewer-intake-form" (scroll)="onScroll()">
      <div
        style="max-width: 100%!important;"
        class="bg-white my-4 rounded"
        *ngFor="let step of field.fieldGroup; let index = index; let last = last"
        id="{{ step?.parent?.key || step?.key }}"
      >
        <formly-field [field]="step"></formly-field>
      </div>
    </div>
  `,
  styles: [
    `.xilo-mono-form-viewer-intake-form {
      height: calc(100vh - 100px);
      overflow-y: auto;
      scroll-behavior: smooth;
        @media only screen and (max-width: 1024px) {
          height: auto;
        }
      }
    `
  ]
})
export class FormIntakeTypeComponent extends FieldType implements OnInit, OnDestroy {
  @ViewChild('intakeForm') intakeForm: ElementRef;
  scrollStateChanged = false;
  private readonly destroyed$ = new ReplaySubject<void>(1);

  constructor(private formViewService: FormViewService) {
    super();
  }

  private isValid(field: FormlyFieldConfig) {
    if (field.key) {
      return field.formControl.valid;
    }

    return field.fieldGroup.every((f) => this.isValid(f));
  }

  ngOnInit() {
    this.formViewService.scrollState.pipe(
      takeUntil(this.destroyed$)
    ).subscribe((key) => {
      if (key) {
        this.scrollStateChanged = true;
        document.getElementById(key)?.scrollIntoView(
          { behavior: 'smooth', block: 'start' }
        );
        setTimeout(() => {
          this.scrollStateChanged = false;
        }, 1000);

      }
    });
  }

  protected onScroll() {
    if (this.scrollStateChanged) {
      return;
    }
    this.intakeForm?.nativeElement?.childNodes?.forEach((child: any) => {
      if (child?.id) {
        if (child?.getBoundingClientRect()?.top < 90 && child?.getBoundingClientRect()?.top > 0) {
          this.formViewService.changeSectionActiveView(child?.id);
        }
      }
    });
  }

  ngOnDestroy() {
    this.destroyed$.next();
  }

}
